import { useEffect, useState } from 'react'
import { ApiClient } from '@storefronts/common-types'
import { R } from '../../modules/api/actions'
import { ClientSelectorProps } from './types'
import { ChevronRight, Check } from 'lucide-react'
import { cn } from '@/lib/utils'

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '../ui/dropdown-menu'

export const ClientSelector: React.FC<ClientSelectorProps> = ({
    client,
    onClientChange,
    className,
}) => {
    const [availableClients, setAvailableClients] = useState<ApiClient[]>([])
    const [open, setOpen] = useState(false)

    useEffect(() => {
        R.getAvailableClients().then((resp) => {
            const clientsSorted = resp.clients.sort((a, b) =>
                a.name.localeCompare(b.name),
            )
            setAvailableClients(clientsSorted)
        })
    }, [])

    if (availableClients.length <= 1) {
        return null
    }

    // Find the current client name
    const currentClient = availableClients.find(
        (c) => c.clientHash === client?.clientHash,
    )
    const currentClientName =
        currentClient?.displayName || currentClient?.name || 'Select client'

    return (
        <div className={cn('w-full', className)}>
            <DropdownMenu open={open} onOpenChange={setOpen}>
                <DropdownMenuTrigger asChild>
                    <button className="flex h-8 w-full items-center justify-between rounded-md px-2 text-sm font-normal bg-transparent hover:bg-accent hover:text-accent-foreground">
                        <span className="mr-1 truncate">
                            {currentClientName}
                        </span>
                        <ChevronRight className="size-4 shrink-0 opacity-50" />
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                    className="max-h-[calc(100vh-20px)] w-56 overflow-auto"
                    align="end"
                    side="right"
                    sideOffset={8}
                >
                    {availableClients.map((c) => (
                        <DropdownMenuItem
                            key={c.clientHash}
                            className={cn(
                                'flex items-center justify-between cursor-pointer',
                                c.clientHash === client?.clientHash &&
                                    'font-medium',
                            )}
                            onClick={() => {
                                onClientChange(c.clientHash)
                                setOpen(false)
                            }}
                        >
                            <span className="truncate">
                                {c.displayName || c.name}
                            </span>
                            {c.clientHash === client?.clientHash && (
                                <Check className="ml-2 size-4" />
                            )}
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    )
}
